export default "__VITE_ASSET__DkV3NF6R__"